// Generated by psc version 0.10.2
"use strict";
var otherwise = true;
module.exports = {
    otherwise: otherwise
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Boolean.purs
// module id = 28
// module chunks = 0